import { createUseStyles } from 'react-jss';
import { FC } from 'react';
import { IconType } from '@/components/icon/helpers';
import { Theme } from '@mui/material';
import Button from '@/components/button';

type Props = {
  icon: IconType;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
};

const useStyles = createUseStyles((theme: Theme) => ({
  button: {
    margin: '0 4px',
    height: `28px !important`,
    padding: '0 8px !important',
    fontSize: theme.typography.caption.fontSize,
    '& svg': {
      height: 16,
      width: 16,
      marginRight: -6,
    },
    border: 'none',
    '&:hover': {
      border: 'none',
    },
  },
}));

const FilterHeaderActionButton: FC<Props> = ({ icon, label, onClick, disabled = false }) => {
  const styles = useStyles();
  return (
    <Button
      type="option"
      icon={icon}
      label={label}
      className={styles.button}
      onClick={onClick}
      disabled={disabled}
    />
  );
};

export default FilterHeaderActionButton;
